import { BaseAPI } from "@utils/base-api";
import { AxiosResponse } from "axios";
import {
  BillingAddressListDto,
} from "@./types/address/dto/billing/BillingAddressList.dto";
import {
  BillingAddressDto,
} from "@./types/address/dto/billing/BillingAddress.dto";
import {
  BillingAddressCreateRequestDto,
} from "@./types/address/dto/billing/BillingAddressCreateRequest.dto";
import {
  BillingAddressUpdateRequestDto,
} from "@./types/address/dto/billing/BillingAddressUpdateRequest.dto";
import {
  ShippingAddressListDto,
} from "@./types/address/dto/shipping/ShippingAddressList.dto";
import {
  ShippingAddressDto,
} from "@./types/address/dto/shipping/ShippingAddress.dto";
import {
  ShippingAddressCreateRequestDto,
} from "@./types/address/dto/shipping/ShippingAddressCreateRequest.dto";
import {
  ShippingAddressUpdateRequestDto,
} from "@./types/address/dto/shipping/ShippingAddressUpdateRequest.dto";

export class AddressesAPI extends BaseAPI {

  public async getAllShippingAddresses(): Promise<AxiosResponse<ShippingAddressListDto>> {
    return this.axios.get(
      "customer/shipping/all",
    );
  }

  public async getShippingAddress(id: number): Promise<AxiosResponse<ShippingAddressDto>> {
    return this.axios.get(
      `customer/shipping/${id}`,
    );
  }

  public async createShippingAddress(
    shippingAddress: ShippingAddressCreateRequestDto,
  ): Promise<AxiosResponse<ShippingAddressDto>> {
    return this.axios.post("customer/shipping", shippingAddress);
  }

  public async updateShippingAddress(
    shippingAddressId: number,
    shippingAddress: ShippingAddressUpdateRequestDto,
  ): Promise<AxiosResponse<ShippingAddressDto>> {
    return this.axios.patch(
      `customer/shipping/${shippingAddressId}`,
      shippingAddress,
    );
  }

  public async getAllBillingAddresses(): Promise<AxiosResponse<BillingAddressListDto>> {
    return this.axios.get(
      "customer/billing/all",
    );
  }

  public async getBillingAddress(id: number): Promise<AxiosResponse<BillingAddressDto>> {
    return this.axios.get(
      `customer/billing/${id}`,
    );
  }

  public async createBillingAddress(
    billingAddress: BillingAddressCreateRequestDto,
  ): Promise<AxiosResponse<BillingAddressDto>> {
    return this.axios.post("customer/billing", billingAddress);
  }

  public async updateBillingAddress(
    billingAddressId: number,
    billingAddress: BillingAddressUpdateRequestDto,
  ): Promise<AxiosResponse<BillingAddressDto>> {
    return this.axios.patch(
      `customer/billing/${billingAddressId}`,
      billingAddress,
    );
  }

}
